module.exports = __webpack_public_path__ + "img/PerfectAudience.428a00a0.svg";